import { Colors, Services } from '@sigma-frontend-libs/commons'

import info from '@/components/info'

export default function(h) {
  let color = Colors.grey
  if (this.state === 'search') {
    color = Colors.warning
  }

  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services.dictionaries}.hints.empty.${this.state}`),
        color
      }
    }
  )
}
